import Vue from 'vue';
import Component from 'vue-class-component';

import useFilters from 'composables/useFilters';
import useCatalogFilters from 'composables/useCatalogFilters';

import closeIcon from 'assets/icons/close_gray.svg';

@Component({
  props: {
    isBoxCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const filterStore = props.isBoxCatalog ? useCatalogFilters() : useFilters();

    const { getCurrentTags, deleteTags } = filterStore;
    return {
      currentTags: getCurrentTags,
      deleteTags,
    };
  },
})
export default class SearchTagsComponent extends Vue {
  icons = {
    closeIcon,
  };

  handleDeleteTag(tagInfo) {
    // At the moment we don't have the feature of manage filters via url, so momentarily i manage only allGiftsMenu category filters via url because it's how it should be
    // So when we reset filters in the store we check if exists route query filters and remove them
    this.deleteTags(tagInfo);
  }
}
